import Vue from "vue";
import VueI18n from "vue-i18n";

const requireLang = require.context("@/lang", true, /\.json$/);

const messages = {};

export const languages = [
  {
    text: "English",
    value: "en-gb",
  },
  {
    text: "中文（简体）",
    value: "zh-cn",
  },
];
for (const file of requireLang.keys()) {
  const path = file.replace(/(\.\/|\.json$)/g, "").split("/");

  path.reduce((o, s, i) => {
    if (o[s]) return o[s];

    o[s] = i + 1 === path.length ? requireLang(file) : {};

    return o[s];
  }, messages);
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale:
    window.localStorage.getItem("language") ||
    navigator.language ||
    navigator.userLanguage ||
    "zh-cn",
  fallbackLocale: "zh-cn",
  messages,
});

export default i18n;
